import { Locale } from "@shared/enums/general"

export interface AuthUser {
  username: string
  email: string
  name: string
  isAdmin: boolean
  userId: string
  locale: Locale
}

export enum AuthType {
  Invalid = "Invalid",
  Authenticated = "Authenticated",
}

export interface AuthState {
  type: AuthType
  user?: AuthUser
  userExpires?: Date
}

export interface AuthenticatedParams {
  user: AuthUser
  csrfToken: string | null
  userExpires: Date
  storeCredentials: boolean
}
